// src/views/Operaciones/LiquidacionClientes/FiltroLiquidacionDeClientes.jsx
import React, { useRef, useEffect, useState } from "react";

import ClienteAutocomplete from "../../../components/autocomplete/ClienteAutocomplete";
import ProductoSelect from "../../../components/autocomplete/ProductoAutocomplete";
import LiquidacionEjecucionAutocomplete from "../../../components/autocomplete/LiquidacionEjecucionAutocomplete";
//import LiquidacionSelect from "../../../components/select/LiquidacionSelect";
import EstadoSelect from "../../../components/select/EstadoSelect";
import IvaSelect from "../../../components/select/IvaSelect";

export default function FiltroLiquidacionDeClientes({
  initialFilters = {},
  onClose = () => {},
  onSubmit = () => {},
}) {
  const filtroRef = useRef(null);

  // =====================================================
  // ESTADO (rehidratable – UI)
  // =====================================================
  const [cliente, setCliente] = useState(initialFilters.cliente ?? null);
  const [producto, setProducto] = useState(initialFilters.producto ?? null);
  const [liquidacionEjecucion, setLiquidacionEjecucion] = useState(
    initialFilters.liquidacionEjecucion ?? null
  );
  const [estado, setEstado] = useState(initialFilters.estado ?? null);
  const [iva, setIva] = useState(initialFilters.iva ?? null);

  // =====================================================
  // ESTADO (primitivos)
  // =====================================================
  const [valorTotal, setValorTotal] = useState(initialFilters.valorTotal ?? "");
  const [valorTotalDescPetr, setValorTotalDescPetr] = useState(
    initialFilters.valorTotalDescPetr ?? ""
  );
  const [valorTotalDescEess, setValorTotalDescEess] = useState(
    initialFilters.valorTotalDescEess ?? ""
  );
  const [valorTotalLibe, setValorTotalLibe] = useState(
    initialFilters.valorTotalLibe ?? ""
  );
  const [qnProducto, setQnProducto] = useState(
    initialFilters.qnProducto ?? ""
  );
  const [valorPrecio, setValorPrecio] = useState(
    initialFilters.valorPrecio ?? ""
  );
  const [valorTotalIva, setValorTotalIva] = useState(
    initialFilters.valorTotalIva ?? ""
  );

  // =====================================================
  // CERRAR CLICK FUERA / ESC
  // =====================================================
  useEffect(() => {
    const outside = (e) => {
      if (filtroRef.current && !filtroRef.current.contains(e.target)) {
        onClose();
      }
    };

    const esc = (e) => e.key === "Escape" && onClose();

    document.addEventListener("mousedown", outside);
    document.addEventListener("keydown", esc);
    return () => {
      document.removeEventListener("mousedown", outside);
      document.removeEventListener("keydown", esc);
    };
  }, [onClose]);

  // =====================================================
  // SUBMIT
  // =====================================================
  const handleSubmit = (e) => {
    e.preventDefault();

    const toNull = (v) =>
      String(v ?? "").trim() === "" ? null : String(v).trim();

    onSubmit({
      // UI (rehidratable)
      cliente,
      producto,
      liquidacionEjecucion,
      estado,
      iva,

      // backend (IDs)
      clienteId: cliente?.id ?? null,
      productoId: producto?.id ?? null,
      liquidacionEjecucionId: liquidacionEjecucion?.id ?? null,
      estadoId: estado?.id ?? null,
      ivaId: iva?.id ?? null,

      // backend (valores)
      valorTotal: toNull(valorTotal),
      valorTotalDescPetr: toNull(valorTotalDescPetr),
      valorTotalDescEess: toNull(valorTotalDescEess),
      valorTotalLibe: toNull(valorTotalLibe),
      qnProducto: toNull(qnProducto),
      valorPrecio: toNull(valorPrecio),
      valorTotalIva: toNull(valorTotalIva),
    });
  };

  // =====================================================
  // RENDER
  // =====================================================
  return (
    <div className="drawer-backdrop">
      <div
        ref={filtroRef}
        onClick={(e) => e.stopPropagation()}
        className="drawer-panel overflow-auto"
      >
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-title">Filtros</h2>
          <button onClick={onClose} className="btn-cancel" title="Cerrar">
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">

          {/* Cliente (autocomplete – legacy search) */}
          <div>
            <label className="form-label-fil">Cliente</label>
            <ClienteAutocomplete value={cliente} onChange={setCliente} />
          </div>

          {/* Producto */}
          <div>
            <label className="form-label-fil">Producto</label>
            <ProductoSelect value={producto} onChange={setProducto} />
          </div>

          {/* Liquidación Ejecución */}
          <div>
            <label className="form-label-fil">Liquidación Ejecución</label>
            <LiquidacionEjecucionAutocomplete
                value={liquidacionEjecucion}
                onChange={setLiquidacionEjecucion}
            />
          </div>

          {/* Estado */}
          <div>
            <label className="form-label-fil">Estado</label>
            <EstadoSelect
              value={estado}
              tipoId={10}
              onChange={setEstado}
            />
          </div>

          {/* IVA */}
          <div>
            <label className="form-label-fil">IVA</label>
            <IvaSelect value={iva} onChange={setIva} />
          </div>

          {/* Numéricos 
          <div>
            <label className="form-label-fil">Valor Total</label>
            <input className="input" value={valorTotal} onChange={(e) => setValorTotal(e.target.value)} />
          </div>

          <div>
            <label className="form-label-fil">Descuento PPOL</label>
            <input className="input" value={valorTotalDescPetr} onChange={(e) => setValorTotalDescPetr(e.target.value)} />
          </div>

          <div>
            <label className="form-label-fil">Descuento EE.SS.</label>
            <input className="input" value={valorTotalDescEess} onChange={(e) => setValorTotalDescEess(e.target.value)} />
          </div>

          <div>
            <label className="form-label-fil">Valor Libe</label>
            <input className="input" value={valorTotalLibe} onChange={(e) => setValorTotalLibe(e.target.value)} />
          </div>*/}

          <div>
            <label className="form-label-fil">Cantidad Producto</label>
            <input className="input" value={qnProducto} onChange={(e) => setQnProducto(e.target.value)} />
          </div>

          <div>
            <label className="form-label-fil">Precio</label>
            <input className="input" value={valorPrecio} onChange={(e) => setValorPrecio(e.target.value)} />
          </div>

          <div>
            <label className="form-label-fil">Total IVA</label>
            <input className="input" value={valorTotalIva} onChange={(e) => setValorTotalIva(e.target.value)} />
          </div>

          <div className="text-right">
            <button type="submit" className="btn">
              Aplicar filtros
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
